// Copyright ©️ 2026 eVolve MEP, LLC

import { FLAT_BLACK_FILLER, FLAT_WHITE_FILLER } from '@evolvemep/api-ts';

import rectangleSvg from 'assets/icons/icon-src/markup/rectangle.svg?raw';
import {
  BaseMarkupTool,
  type MarkupToolContext,
  type PanelConfig,
} from 'components/Autodesk/extensions/MarkupModeExtension/BaseMarkupTool';

const { Autodesk } = window;

export class RectangleTool extends BaseMarkupTool {
  readonly type = 'rectangle'; // Matches the existing type used by Autodesk's rectangle markup tool, which we build on top of.

  constructor(context: MarkupToolContext) {
    super(context, {
      strokeWidth: 2,
      strokeColor: FLAT_BLACK_FILLER,
      strokeOpacity: 100,
      fillColor: FLAT_WHITE_FILLER,
      fillOpacity: 50,
    });
  }

  protected getPanelConfig(): PanelConfig {
    return {
      panelTitle: 'Rectangle',
      sections: [
        {
          heading: 'Outline',
          fields: [
            { property: 'stroke-width', label: 'Size' },
            { property: 'stroke-color', colorLabel: 'Color', opacityLabel: 'Opacity' },
          ],
        },
        {
          heading: 'Fill',
          fields: [{ property: 'fill-color', colorLabel: 'Color', opacityLabel: 'Opacity' }],
        },
      ],
    };
  }

  protected activateEditMode() {
    const rectangleEditMode = new Autodesk.Viewing.Extensions.Markups.Core.EditModeRectangle(this.markupExtension);
    this.markupExtension.changeEditMode(rectangleEditMode);
  }

  protected readonly buttonIcon = rectangleSvg;
  protected readonly buttonTooltip = 'Rectangle';
}
